"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClientNameAndUid_1 = require("./ClientNameAndUid");
exports.ClientNameAndUid = ClientNameAndUid_1.default;
var FormattedAddress_1 = require("./FormattedAddress");
exports.FormattedAddress = FormattedAddress_1.default;
//# sourceMappingURL=index.js.map